<template>
  <div class="wrap short">
    <div class="title" v-if="this.period <= '2' && this.timeframe == 'hours'">Last hour</div>
    <div class="title" v-else>Last {{ this.period }} {{ this.timeframe }}</div>
    <div class="subtitle" v-if="!loading">
      {{ this.totalBookings | formatNumbers }}
    </div>
    <b-loading v-model="this.loading" :is-full-page="false" :can-cancel="false" append-to-body><b-icon icon="spinner" pack="fas" custom-class="fa-spin" size="is-large"></b-icon></b-loading>
  </div>
</template>

<script>
const utc = require("dayjs/plugin/utc");
const axios = require("axios");
const dayjs = require("dayjs");
dayjs.extend(utc);
export default {
  components: {},
  props: {
    customerid: {
      type: String,
      required: true,
    },
    period: {
      type: Number,
      required: false,
      default: 1,
    },
    timeframe: {
      type: String,
      required: false,
      default: "week",
    },
    region: {
      type: String,
      required: false,
    },
    customers: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      apiUrl: "https://api.jeak.co.uk",
      stats: [],
      backgroundTimer: {},
      lastRefresh: "",
      nextRefresh: "",
      loading: true,
      totalBookings: 0,
    };
  },
  methods: {
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      let fromDate = dayjs().subtract(this.period, this.timeframe).utc().format();
      let toDate = dayjs().utc().format();
      let url = this.customerid > 0 ? `/stats/dashboard/${this.customerid}?from=${fromDate}&to=${toDate}` : `/stats/dashboard?from=${fromDate}&to=${toDate}`;
      axios.get(this.apiUrl + url, config).then((response) => {
        this.loading = false;
        this.stats = response.data;
        this.lastRefresh = dayjs().format("hh:mm");
        this.nextRefresh = dayjs().add(1, "hour").format("hh:05");
        this.CalculateTotal();
      });
    },
    GetItemsDaily: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      let fromDate = dayjs().subtract(this.period, this.timeframe).utc().format("YYYY-MM-DD");
      let toDate = dayjs().utc().format("YYYY-MM-DD");

      const response = await axios.get(this.apiUrl + `/stats/customer/outcomes?from=${fromDate}&to=${toDate}`, config);
      this.loading = false;
      this.stats = response.data;
      //console.log(this.stats);
      this.lastRefresh = dayjs().format("hh:mm");
      this.nextRefresh = dayjs().add(1, "hour").format("hh:05");
      this.CalculateTotalDaily();
    },
    CalculateTotalDaily: async function () {
      for (const [date, timeData] of Object.entries(this.stats)) {
        for (const [time, customerData] of Object.entries(timeData)) {
          if (this.customerid > 0) {
            if (customerData[this.customerid].Booked) {
              this.totalBookings += customerData[this.customerid].Booked;
            }
          } else if (this.region > 0) {
            for (const [customerId, customData] of Object.entries(customerData)) {
              if (this.customers[customerId].region_id == this.region) {
                for (const [outcome, count] of Object.entries(customData)) {
                  if (outcome.toLowerCase() === "booked") {
                    this.totalBookings += count;
                  }
                }
              }
            }
          } else {
            for (const [outcome, count] of Object.entries(customerData)) {
              if (outcome.toLowerCase() === "booked") {
                this.totalBookings += count;
              }
            }
          }
        }
      }
    },
    CalculateTotal: async function () {
      for (const [date, timeData] of Object.entries(this.stats)) {
        for (const [time, customerData] of Object.entries(timeData)) {
          if (this.customerid > 0) {
            if (customerData[this.customerid].Booked) {
              this.totalBookings += customerData[this.customerid].Booked;
            }
          } else if (this.region > 0) {
            for (const [customerId, customData] of Object.entries(customerData)) {
              if (this.customers[customerId].region_id == this.region) {
                for (const [outcome, count] of Object.entries(customData)) {
                  if (outcome.toLowerCase() === "booked") {
                    this.totalBookings += count;
                  }
                }
              }
            }
          } else {
            for (const [customerId, customData] of Object.entries(customerData)) {
              for (const [outcome, count] of Object.entries(customData)) {
                if (outcome.toLowerCase() === "booked") {
                  this.totalBookings += count;
                }
              }
            }
          }
        }
      }
    },
  },
  filters: {
    formatNumbers: function (value) {
      return value.toLocaleString();
    },
  },
  mounted() {
    if (this.timeframe != "day" && this.timeframe != "hour" && this.timeframe != "hours") {
      this.GetItemsDaily();
    } else {
      this.GetItems();
    }
  },
};
</script>

<style scoped>
.wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.title {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.subtitle {
  font-size: min(5vw, 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
